import {
  commons,
  concessionLetterRequired,
  others,
  termoMAI,
} from '../constants';
import { initialValuesGenerator } from '../initialValueGenerator';
import { dynamicRule } from '../rules';

export const MAIOptanteDocs = () => {
  const rules = {
    anexoRG: dynamicRule('required'),
    anexoCPF: dynamicRule('required'),
    anexoCarta: dynamicRule('required'),
    anexoTermoMAI: dynamicRule(),
    anexoOutros: dynamicRule(),
  };

  const docs = {
    commons: [...commons, ...concessionLetterRequired, ...termoMAI, ...others],
  };

  const initialValues = initialValuesGenerator(docs);

  return {
    initialValues,
    rules,
    docs,
  };
};
